import { z } from 'zod';

export const cdcAuthContextSchema = z.object({
  userId: z.string().nullish(),
  organizationId: z.string().nullish(),
  organizationName: z.string().nullish(),
  authType: z.enum(['user', 'system']).nullish(),
  module: z.string().nullish(),
  operation: z.string().nullish(),
});

export const baseCdcEventDataSchema = z.object({
  eventId: z.string(),
  timestamp: z.string(),
});

export const cdcEventModule = z.enum([
  'item-store',
  'capacity',
  'adaptive-planner',
  'id',
  'work-integration',
  'reporting-store',
  'finance',
  'demand',
  'objectives',
]);
export const cdcEventType = z.enum([
  'created',
  'updated_full',
  'updated_partial',
  'deleted',
  'anonymized',
]);

export const CDC_METADATA_USER_AGENT_KEY = 'userAgent';
export const CDC_METADATA_AUTH_TYPE_KEY = 'authType';
export const CDC_METADATA_MODULE_KEY = 'module';
export const CDC_METADATA_OPERATION_KEY = 'operation';
